import React from 'react';

import ContactPerson from '../../../components/Molecules/ContactPerson';

const NodeContactPerson = ({ entity, className }) => (
  <ContactPerson
    className={className}
    title={entity.getIn(['title', 0, 'value'], '')}
    role={entity.getIn(['field_function', 0, 'value'], '')}
    phoneNumber={entity.getIn(['field_phone_number', 0, 'value'], '')}
    email={entity.getIn(['field_email', 0, 'value'], '')}
  />
);

export default NodeContactPerson;
